import {
  BrancheDto,
  BrancheDtoBrancheEnum,
  DossierResponseDto,
} from 'lib_api/lib/api/gen';

const BRANCHES_AVEC_FICHE_JUDICIAIRE = [
  BrancheDtoBrancheEnum.ADMINISTRATIVE,
  BrancheDtoBrancheEnum.INERTE,
];
export function isJusticeFieldRequiredByBranche(
  justiceActive: boolean,
  branche?: BrancheDto | null,
): boolean {
  if (!justiceActive) {
    return false;
  }
  return branche?.branche === BrancheDtoBrancheEnum.INERTE;
}

export const shouldDisplayJusticeFeature = (
  dossier: DossierResponseDto,
  justiceActive: boolean,
): boolean => {
  return shouldDisplayJusticeFeatureBasedOnBranche(
    justiceActive,
    dossier.computed?.currentBrancheWorkflow,
  );
};

export function shouldDisplayJusticeFeatureBasedOnBranche(
  justiceActive: boolean,
  branche?: BrancheDto | null,
): boolean {
  if (!justiceActive) {
    return false;
  }
  return isBrancheJustice(branche?.branche);
}

const isBrancheJustice = (branche?: BrancheDtoBrancheEnum): boolean => {
  return !!branche && BRANCHES_AVEC_FICHE_JUDICIAIRE.includes(branche);
};
